import { trainingprogram } from '../../../../lib/apiList'
import axios from '../../../../lib/axios'
import { Questionnaire } from '../type'

export const viewResouce = async (id: string) => {
    const response = await axios.get(
        `${trainingprogram.VIEWRESOURCE}${id}/resource`
    )
    return response
}

export const uploadTask = async (data: any) => {
    const response = await axios.post(trainingprogram.UPLOADTASK, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response
}

export const delResource = async (id: string) => {
    const response = await axios.delete(trainingprogram.DELRESOURCE, {
        data: { resourceId: id },
    })
    return response
}

export const createQuestions = async (data: Questionnaire) => {
    const response = await axios.post(trainingprogram.CREATEQUESTIONNAIRE, data)
    return response
}

export const viewResourceDetail = async (resourceid: string) => {
    const response = await axios.get(
        `${trainingprogram.RESOURCEDETAILS}${resourceid}`
    )
    return response
}

export const getQuestions = async (resourceId: string) => {
    const url = `${trainingprogram.CREATEQUESTIONNAIRE}/${resourceId}`
    const response = await axios.get(url)
    return response
}

export const getTaskList = async (id: string) => {
    const url = trainingprogram.TASKSLIST.replace('{id}', id)
    const response = await axios.get(url)
    return response
}

export const markAsCompleted = async (id: string) => {
    const url = trainingprogram.MARKASCOMPLETED.replace('{id}', id)
    const response = await axios.put(url)
    return response
}

export const viewResourceLink = async (id: string, type: string) => {
    const url = trainingprogram.VIEWRESOURCELINK.replace('{id}', id)
    const response = await axios.post(`${url}${type}`)
    return response
}
